import { useCallback, useState } from "react";
import { TableSortState } from "shared/types/tableSort";

// Lifts an AntD Table's sorter into page state so the PDF export can mirror
// the on-screen order (column + direction; AntD's cleared tri-state maps to
// null = the report's default ranking). Compose `onSortChange` with the
// page's existing Table onChange handler (page memory etc.).
export const useTableSort = () => {
  const [sortState, setSortState] = useState<TableSortState>(null);

  // AntD hands the sorter as an object (single-sort tables) whose `order`
  // is undefined once the user clears the sort on the third click.
  // Stable, so a page may list it as an effect dependency.
  const onSortChange = useCallback((sorter: unknown) => {
    const s = Array.isArray(sorter) ? sorter[0] : sorter;
    const field = (s as { field?: unknown; columnKey?: unknown })?.field;
    const order = (s as { order?: "ascend" | "descend" | null })?.order;
    if (field && order) setSortState({ key: String(field), order });
    else setSortState(null);
  }, []);

  return { sortState, onSortChange };
};
